export const FileUploadHandlers = (
  id,
  file_checker_ok,
  file_checker_not_ok
) => {
  let img_width, img_height, doc;
  try {
    doc = document.getElementById(id);
  } catch (e) {
    file_checker_not_ok(id, e);
    return false;
  }
  const file = doc.files[0].size / 1000;
  if (
    doc.files[0].type === 'image/jpeg' ||
    doc.files[0].type === 'image/jpg' ||
    doc.files[0].type === 'image/png'
  ) {
    //    Check Size of the Image
    if (file > 4000) {
      file_checker_not_ok(id, 'Image Size Should be lesser than 4MB');
      doc.value = '';
      return false;
    }

    // Check Resolution of the Image
    let new_img = new Image();
    let reader = new FileReader();
    reader.readAsDataURL(doc.files[0]);
    reader.onloadend = function() {
      new_img.src = reader.result;

      new_img.onload = function() {
        img_width = new_img.width;
        img_height = new_img.height;
        if (
          img_width < 350 ||
          img_width > 32000 ||
          img_height < 240 ||
          img_height > 32000
        ) {
          file_checker_not_ok(
            id,
            'Image Resolution should be inbetween 350x240 and  32000x32000'
          );
          doc.value = '';
          return false;
        }
        try {
          file_checker_ok(id);
          // Upload(file_,upload_data, Ocr_event, setChanged, close_event,voterId,)
        } catch (e) {
          file_checker_not_ok(id, e);
        }
      };
    };
  } else if (doc.files[0].type === 'application/pdf') {
    if (file > 2000) {
      file_checker_not_ok(id, 'PDF Size Should be lesser than 2MB');
      doc.value = '';
      return false;
    }
    file_checker_ok(id);
  } else {
    file_checker_not_ok(
      id,
      "Image/File should be 'jpeg', 'png', 'jpg', 'pdf' only"
    );
    doc.value = '';
    return false;
  }
};
